import { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withStyles } from "@mui/styles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import Menu from "@mui/material/Menu";
import ListItemIcon from "@mui/material/ListItemIcon";
import MenuItem from "@mui/material/MenuItem";
import SettingsIcon from "@mui/icons-material/Settings";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import HomeIcon from "@mui/icons-material/Home";
import Delete from "@mui/icons-material/Delete";
import Assignment from "@mui/icons-material/Assignment";
import NewReleases from "@mui/icons-material/NewReleases";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import SyncIcon from "@mui/icons-material/Sync";
import ProfileIcon from "@mui/icons-material/AccountBox";
import ProfileModal from "./Layout/ProfileModal";
import { Link } from "react-router-dom";
import logo from "../images/Logo.png";
import {
    loadLocationTitle,
    setDebugging,
    getActiveDayNeeded,
} from "../redux/contextInfos/contextInfosActions";
import { clearUsers } from "../redux/users/usersActions";
import { getImputationToDelete } from "../redux/imputations/imputationsActions";
import withAuth from "./withAuth";
import { getActiveDay } from "../redux/day/dayActions";
import {
    changeProfileModalState,
    downloadHabilitationCard,
    loadLoggedEmployee,
} from "../redux/employees/loggedEmployeeActions";
import { getMyLiquidBottles } from "../redux/liquidBottles/liquidBottlesActions";
import "./MenuAppBar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import AutoRenewIcon from "@mui/icons-material/Autorenew";
import WarningIcon from "@mui/icons-material/Warning";
import { actualizeWaitingRequests } from "../redux/serviceWorker/swActions";
import { getStateAccessor } from "../lib/evaluateStringAsCodeHelper";
import { clearComponentsSearch } from "../redux/componentsPark/componentsParkActions";
import { clearLiquidBottle } from "../redux/liquidBottles/liquidBottlesActions";
import { IRIS_LINK, MULTIPLE_CLICK_TIMEOUT } from "../constants";
import { goToNews } from "../redux/news/newsActions";
import { currentImputationsFetchData } from "../redux/imputations/imputationsEditionActions";

const styles = {
    flex: {
        flex: 1,
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
    },
    logoutButton: {
        background: "#FE5815",
        border: "none!important",
        fontSize: "1rem!important",
        width: "auto",
    },
};

class MenuAppBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            auth: this.props.activeUser !== null,
            nbLogoClick: 0,
            anchorEl: null,
        };

        this.props.loadActiveUser((user) => {
            if (!user) return;

            this.props.getSynchroActiveUser(this.state, true);
            // this.props.loadLoggedEmployee(props.activeUser.id, props.activeUser.emp_id);
            this.props.getMyLiquidBottles(props.activeUser, true);
        });
    }

    componentDidMount() {
        this.props.loadLocationTitle();

        if (
            this.props.activeUser !== null &&
            getActiveDayNeeded(this.props.location.pathname)
        ) {
            this.props.getActiveDay(this.props.activeUser.id);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.intervention && nextProps.intervention) {
            if (
                this.props.intervention.currentIntervention !==
                nextProps.intervention.currentIntervention
            )
                return true;

            if (
                this.props.intervention.currentIntervention &&
                nextProps.intervention.currentIntervention &&
                this.props.intervention.currentIntervention.name !==
                    nextProps.intervention.currentIntervention.name
            )
                return true;
        }

        return (
            this.props.hideMenu !== nextProps.hideMenu ||
            this.props.waitingRequests.length !==
                nextProps.waitingRequests.length ||
            this.props.locationTitle !== nextProps.locationTitle ||
            this.state.anchorEl !== nextState.anchorEl
        );
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let modifiedState = prevState;

        if (nextProps.activeUser !== modifiedState.activeUser) {
            modifiedState.activeUser = nextProps.activeUser;
            if (
                getActiveDayNeeded(nextProps.location.pathname) &&
                nextProps.activeUser !== undefined
            )
                nextProps.getActiveDay(nextProps.activeUser.id);
        }

        return modifiedState;
    }

    handleChange(event, checked) {
        this.setState({ auth: checked });
    }

    handleMenu(event) {
        this.setState({ anchorEl: event.currentTarget });
    }

    viewProfile() {
        this.props.changeProfileModalState(true);
    }

    handleClose() {
        this.setState({ anchorEl: null });
    }

    goBack() {
        if (this.props.history.location.pathname.startsWith("/absences/"))
            this.props.history.push("/absences");
        else if (this.props.history.location.pathname.startsWith("/absences")) {
            this.props.history.push("/");
        } else if (
            this.props.history.location.pathname.startsWith(
                "/interventions/intervention/preview"
            )
        ) {
            this.props.history.push("/interventions/intervention");
        } else if (
            this.props.history.location.pathname.startsWith(
                "/interventions/intervention/controlSignature"
            )
        ) {
            this.props.history.push("/interventions/intervention");
        } else if (
            this.props.history.location.pathname.startsWith("/interventions/intervention/signature")
        ) {
            this.props.history.push("/interventions/intervention/controlSignature");
        } else if (
            this.props.history.location.pathname.startsWith("/interventions/")
        ) {
            this.props.history.push("/interventions");
        } else if (
            this.props.history.location.pathname.startsWith("/interventions")
        ) {
            this.props.history.push("/");
        } else if (
            this.props.history.location.pathname.startsWith("/fluide") &&
            this.props.liquidBottle
        ) {
            this.props.clearLiquidBottle();
        } else if (
            this.props.history.location.pathname.startsWith(
                "/componentsPark"
            ) &&
            this.props.componentsPark.componentSearch
        ) {
            this.props.clearComponentsSearch();
        } else if (
            this.props.history.location.pathname.startsWith("/siteMonitorings/")
        ) {
            this.props.history.push("/siteMonitorings");
        } else if (
            this.props.history.location.pathname.startsWith("/siteMonitorings")
        ) {
            this.props.history.push("/");
        } else if (
            this.props.history.location.pathname.startsWith("/humanResources/")
        ) {
            this.props.history.push("/humanResources");
        } else if (
            this.props.history.location.pathname.startsWith("/humanResources")
        ) {
            this.props.history.push("/");
        } else if (
            this.props.history.location.pathname.startsWith(
                "/epis/epi/form"
            )
        ) {
            this.props.history.push("/epis/epi");
        } else if (
            this.props.history.location.pathname.startsWith("/epis/epi") || 
            this.props.history.location.pathname.startsWith("/epis/declare") 
        ) {
            this.props.history.push("/epis");
        } else if (
            this.props.history.location.pathname.startsWith("/epis")
        ) {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }
    }

    onLogoClick() {
        if (this.state.nbLogoClick) {
            clearTimeout(this.state.logoClickTimeout);
        }

        this.setState({
            nbLogoClick: this.state.nbLogoClick + 1,
            logoClickTimeout: setTimeout(() => {
                if (this.state.nbLogoClick === 5) {
                    if (
                        this.props.context.debugging ||
                        window.confirm(
                            "Le mode debug va se lancer. Ce mode est exclusivement réservé aux administrateurs. Êtes-vous sûr de vouloir continuer?"
                        )
                    )
                        this.props.setDebugging(!this.props.context.debugging);
                }

                this.setState({
                    nbLogoClick: 0,
                });
            }, MULTIPLE_CLICK_TIMEOUT),
        });
    }

    goHome() {
        this.props.history.push("/");
    }

    logout() {
        this.props.clearUsers();
        this.props.history.replace("/Login");
    }

    signout() {
        this.props.clearUsers();
        this.props.history.replace("/Login");
    }

    emptyDay() {
        this.props.getImputationToDelete(this.props.activeUser.id, true);
    }

    getAllCurrentImputations() {
        if (this.props.current_day && !this.props.current_day.validation) {
            if (!window.confirm(
                "Les données présentes sur MyOpen seront écrasées.\r\n Continuer ?"
            ))
                return;
            // Suppression sur MyOpen des imputations de la journée liées à l'utilisateur courant
            this.props.getImputationToDelete(this.props.activeUser.id, true);
            // Ajout des imputations de la journée liées à l'utilisateur courant et en provenance d'OpenERP
            this.props.currentImputationsFetchData(this.props.current_day, this.props.activeUser);
        }
    }

    synchronization() {
        this.props.synchronization(
            this.state,
            getStateAccessor(this.props),
            this.props.history,
            this.props.interventionsFilters,
            this.props.siteMonitoringsFilters,
            true
        );
    }

    whatSNew() {
        goToNews(this.props.currentNews);
    }

    redirectToIris() {
        window.open(IRIS_LINK, "_blank");
    }

    render() {
        const { classes } = this.props;
        const anchorEl = this.state.anchorEl;
        const open = Boolean(anchorEl);
        let tab = [];

        tab.push(<MenuItem
            key={1}
            onClick={this.getAllCurrentImputations.bind(
                this
            )}
            style={{
                margin: "auto",
                display: "flex",
            }}
        >
            <ListItemIcon
                className={
                    "col-lg-3 col-md-3 col-sm-3 col-3 " +
                    classes.icon
                }
                style={{ color: "#FE5814" }}
            >
                <ArrowDownwardIcon />
            </ListItemIcon>
            <Typography
                className="col-lg-9 col-md-9 col-sm-9 col-9"
                style={{
                    color: "#005BBA",
                    fontSize: 20,
                }}
            >
                Récupérer lignes de temps
            </Typography>
        </MenuItem>);
        tab.push(<MenuItem
            key={2}
            onClick={this.emptyDay.bind(this)}
            style={{
                margin: "auto",
                display: "flex",
            }}
        >
            <ListItemIcon
                className={
                    "col-lg-3 col-md-3 col-sm-3 col-3 " +
                    classes.icon
                }
                style={{ color: "#FE5814" }}
            >
                <Delete />
            </ListItemIcon>
            <Typography
                className="col-lg-9 col-md-9 col-sm-9 col-9"
                style={{
                    color: "#005BBA",
                    fontSize: 20,
                }}
            >
                Vider jour
            </Typography>
        </MenuItem>);

        let waitingRequestsBtn = null;

        let locationTitle = this.props.locationTitle.toUpperCase();
        let gotNews = this.props.currentNews && this.props.currentNews.url;
        let isDayValidated = this.props.current_day ? this.props.current_day.validation : false;

        if (
            this.props.intervention &&
            this.props.intervention.name &&
            this.props.location.pathname === "/interventions/intervention"
        )
            locationTitle = "OT " + this.props.intervention.name;

        if (
            this.props.siteMonitoring &&
            this.props.siteMonitoring.currentSiteMonitoring &&
            this.props.siteMonitoring.currentSiteMonitoring.code &&
            this.props.location.pathname === "/siteMonitorings/siteMonitoring"
        )
            locationTitle =
                this.props.siteMonitoring.currentSiteMonitoring.code;

        if (
            this.props.currentInterview &&
            this.props.location.pathname === "/humanResources/form"
        )
            locationTitle = this.props.currentInterview.plan.name;

        if (
            this.props.waitingRequests.length > 0 &&
            this.props.location.pathname === "/"
        )
            waitingRequestsBtn = (
                <Tooltip id="tooltip-icon" title="Actions en attente de réseau">
                    <Button
                        className="badge-div-center white_button"
                        onClick={this.synchronization.bind(this)}
                    >
                        <AutoRenewIcon
                            className="white-icon margin-auto-renew-btn"
                            fontSize="large"
                        />
                        <span className="badge activity-badge-notify">
                            {this.props.waitingRequests.length}
                        </span>
                        <WarningIcon
                            className="badge warn-badge"
                            color="secondary"
                            style={{ fontSize: 25 }}
                        />
                    </Button>
                </Tooltip>
            );

        return (
            <div
                style={{
                    width: "100%",
                    height: "auto",
                    maxHeight: "15%",
                    display: "inline-flex",
                    zIndex: "1055"
                }}
                className={
                    this.props.hideMenu ? "hide-sticky-menu" : "sticky-menu"
                }
            >
                <ProfileModal />
                <AppBar
                    position="static"
                    style={{ maxHeight: "100%", height: "100%" }}
                >
                    <Toolbar
                        style={{
                            maxHeight: "100%",
                            height: "100%",
                            minHeight: "100%",
                            padding: "0px",
                            backgroundColor: "rgba(0, 97, 187, 0.5)",
                        }}
                    >
                        {this.props.location.pathname !== "/" ? (
                            <div>
                                <Button
                                    color="inherit"
                                    aria-label="Back"
                                    onClick={this.goBack.bind(this)}
                                    className="white_button"
                                >
                                    <ArrowBackIcon />
                                </Button>
                                <Button
                                    color="inherit"
                                    aria-label="Home"
                                    onClick={this.goHome.bind(this)}
                                    className="white_button"
                                >
                                    <HomeIcon />
                                </Button>
                            </div>
                        ) : (
                            <div></div>
                        )}

                        <Typography
                            variant="h6"
                            color="inherit"
                            className={classes.flex}
                            style={{
                                maxHeight: "100%",
                                overflowY: "hidden",
                                fontSize: 16,
                                paddingLeft: "5px",
                            }}
                        >
                            {locationTitle}
                        </Typography>
                        {waitingRequestsBtn}
                        {this.props.location.pathname === "/activity" && (
                            <div
                                style={{
                                    borderStyle: "solid",
                                    borderWidth: "0px 1px 0px 0px",
                                    borderColor: "#FFFFFF",
                                }}
                            >
                                <Tooltip
                                    id="tooltip-icon"
                                    title="Rapport d'activité"
                                >
                                    <Button
                                        component={Link}
                                        to="/activity/report"
                                        color="inherit"
                                        className="white_button"
                                    >
                                        <svg
                                            viewBox="0 0 682.66669 600"
                                            className={classes.icon}
                                            style={{
                                                flexShrink: 0,
                                                height: "32px",
                                                paddingTop: "5%",
                                                paddingBottom: "5%",
                                            }}
                                        >
                                            <g transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)">
                                                <path
                                                    d="M 0,0 145.85,146.385 159.892,132.347 14.042,-14.038 Z"
                                                    fill="#ffffff"
                                                    transform="translate(276.1084,290.1909)"
                                                />
                                                <path
                                                    d="M 0,0 15.587,15.644 61.075,-29.677 45.488,-45.321 Z"
                                                    fill="#ffffff"
                                                    transform="translate(185.5854,321.4351)"
                                                />
                                                <path
                                                    d="M 0,0 82.52,82.52 98.135,66.904 15.616,-15.615 Z"
                                                    fill="#ffffff"
                                                    transform="translate(57.8525,254.5547)"
                                                />
                                                <g>
                                                    <path
                                                        d="m 0,0 c 0,-22.55 -18.28,-40.83 -40.83,-40.83 -22.55,0 -40.83,18.28 -40.83,40.83 0,22.55 18.28,40.83 40.83,40.83 C -18.28,40.83 0,22.55 0,0"
                                                        fill="#ffffff"
                                                        transform="translate(451.9482,417.8301)"
                                                    />
                                                    <path
                                                        d="m 0,0 c 0,-22.55 -18.28,-40.83 -40.83,-40.83 -22.55,0 -40.83,18.28 -40.83,40.83 0,22.55 18.28,40.83 40.83,40.83 C -18.28,40.83 0,22.55 0,0"
                                                        fill="#ffffff"
                                                        transform="translate(302.0957,261.2656)"
                                                    />
                                                    <path
                                                        d="m 0,0 c 0,-22.55 -18.28,-40.83 -40.83,-40.83 -22.55,0 -40.83,18.28 -40.83,40.83 0,22.55 18.28,40.83 40.83,40.83 C -18.28,40.83 0,22.55 0,0"
                                                        fill="#ffffff"
                                                        transform="translate(211.5537,351.8081)"
                                                    />
                                                    <path
                                                        d="m 0,0 c 0,-22.55 -18.28,-40.83 -40.83,-40.83 -22.55,0 -40.83,18.28 -40.83,40.83 0,22.55 18.28,40.83 40.83,40.83 C -18.28,40.83 0,22.55 0,0"
                                                        fill="#ffffff"
                                                        transform="translate(83.8086,224.0635)"
                                                    />
                                                </g>
                                            </g>
                                        </svg>
                                    </Button>
                                </Tooltip>
                            </div>
                        )}
                        {this.state.auth && (
                            <div>
                                <Button
                                    aria-owns={open ? "menu-appbar" : null}
                                    aria-haspopup="true"
                                    onClick={this.handleMenu.bind(this)}
                                    color="inherit"
                                    className="white_button"
                                >
                                    <ProfileIcon fontSize="large" />
                                </Button>
                                <Menu
                                    id="menu-appbar"
                                    anchorEl={anchorEl}
                                    anchorOrigin={{
                                        vertical: "top",
                                        horizontal: "right",
                                    }}
                                    transformOrigin={{
                                        vertical: "top",
                                        horizontal: "right",
                                    }}
                                    open={open}
                                    onClose={this.handleClose.bind(this)}
                                >
                                    <MenuItem
                                        style={{ display: "flex" }}
                                        onClick={this.onLogoClick.bind(this)}
                                    >
                                        <img
                                            src={logo}
                                            alt="logo"
                                            style={{ width: "250px" }}
                                        />
                                    </MenuItem>
                                    <Typography
                                        className="col-lg-9 col-md-9 col-sm-9 col-9"
                                        style={{
                                            color: "#005BBA",
                                            fontSize: 12,
                                        }}
                                    >
                                        Version {process.env.REACT_APP_VERSION}
                                    </Typography>
                                    <MenuItem
                                        onClick={this.viewProfile.bind(this)}
                                    >
                                        <ListItemIcon
                                            className={
                                                "col-lg-3 col-md-3 col-sm-3 col-3 " +
                                                classes.icon
                                            }
                                            style={{ color: "#FE5814" }}
                                        >
                                            <ProfileIcon />
                                        </ListItemIcon>
                                        <Typography
                                            className="col-lg-9 col-md-9 col-sm-9 col-9"
                                            style={{
                                                fontSize: 20,
                                                color: "#005BBA",
                                            }}
                                        >
                                            {this.props.activeUser !== undefined
                                                ? this.props.activeUser.name
                                                : ""}
                                        </Typography>
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() =>
                                            this.props.downloadHabilitationCard(
                                                this.props.activeUser
                                            )
                                        }
                                        color="secondary"
                                        style={{
                                            margin: "auto",
                                            display: "flex",
                                        }}
                                    >
                                        <ListItemIcon
                                            className={
                                                "col-lg-3 col-md-3 col-sm-3 col-3 " +
                                                classes.icon
                                            }
                                            style={{ color: "#FE5814" }}
                                        >
                                            <Assignment />
                                        </ListItemIcon>
                                        <Typography
                                            className="col-lg-9 col-md-9 col-sm-9 col-9"
                                            style={{
                                                color: "#005BBA",
                                                fontSize: 20,
                                            }}
                                        >
                                            {"Carte d'habilitation"}
                                        </Typography>
                                    </MenuItem>

                                    {gotNews ? (
                                        <MenuItem
                                            onClick={this.whatSNew.bind(this)}
                                            color="secondary"
                                            style={{
                                                margin: "auto",
                                                display: "flex",
                                            }}
                                        >
                                            <ListItemIcon
                                                className={
                                                    "col-lg-3 col-md-3 col-sm-3 col-3 " +
                                                    classes.icon
                                                }
                                                style={{ color: "#FE5814" }}
                                            >
                                                <NewReleases />
                                                {!this.props.currentNews
                                                    .read ? (
                                                    <span className="badge">
                                                        {1}
                                                    </span>
                                                ) : null}
                                            </ListItemIcon>
                                            <Typography
                                                className="col-lg-9 col-md-9 col-sm-9 col-9"
                                                style={{
                                                    color: "#005BBA",
                                                    fontSize: 20,
                                                }}
                                            >
                                                {"Nouveautés"}
                                            </Typography>
                                        </MenuItem>
                                    ) : null}
                                    <MenuItem
                                        onClick={this.redirectToIris}
                                        color="secondary"
                                        style={{
                                            margin: "auto",
                                            display: "flex",
                                        }}
                                    >
                                        <ListItemIcon
                                            className={
                                                "col-lg-3 col-md-3 col-sm-3 col-3 " +
                                                classes.icon
                                            }
                                            style={{ color: "#FE5814" }}
                                        >
                                            <MenuBookIcon />
                                        </ListItemIcon>
                                        <Typography
                                            className="col-lg-9 col-md-9 col-sm-9 col-9"
                                            style={{
                                                color: "#005BBA",
                                                fontSize: 20,
                                            }}
                                        >
                                            {"IRIS"}
                                        </Typography>
                                    </MenuItem>
                                    <MenuItem
                                        onClick={this.synchronization.bind(
                                            this
                                        )}
                                        color="secondary"
                                        style={{
                                            margin: "auto",
                                            display: "flex",
                                        }}
                                    >
                                        <ListItemIcon
                                            className={
                                                "col-lg-3 col-md-3 col-sm-3 col-3 " +
                                                classes.icon
                                            }
                                            style={{ color: "#FE5814" }}
                                        >
                                            <SyncIcon />
                                        </ListItemIcon>
                                        <Typography
                                            className="col-lg-9 col-md-9 col-sm-9 col-9"
                                            style={{
                                                color: "#005BBA",
                                                fontSize: 20,
                                            }}
                                        >
                                            Synchroniser
                                        </Typography>
                                    </MenuItem>
                                    <MenuItem
                                        component={Link}
                                        to="/parameters"
                                        color="secondary"
                                        style={{
                                            margin: "auto",
                                            display: "flex",
                                        }}
                                    >
                                        <ListItemIcon
                                            className={
                                                "col-lg-3 col-md-3 col-sm-3 col-3 " +
                                                classes.icon
                                            }
                                            style={{ color: "#FE5814" }}
                                        >
                                            <SettingsIcon />
                                        </ListItemIcon>
                                        <Typography
                                            className="col-lg-9 col-md-9 col-sm-9 col-9"
                                            style={{
                                                color: "#005BBA",
                                                fontSize: 20,
                                            }}
                                        >
                                            Système
                                        </Typography>
                                    </MenuItem>
                                    {this.props.location.pathname === "/activity" &&
                                    !isDayValidated &&
                                    (
                                        tab.map(t => t)
                                    )}
                                    <MenuItem
                                        onClick={this.signout.bind(this)}
                                        style={{
                                            margin: "auto",
                                            display: "flex",
                                        }}
                                    >
                                        <ListItemIcon
                                            className={
                                                "col-lg-3 col-md-3 col-sm-3 col-3 " +
                                                classes.icon
                                            }
                                            style={{ color: "#FE5814" }}
                                        >
                                            <FontAwesomeIcon
                                                icon={faSignOutAlt}
                                                className="fa-lg"
                                            />
                                        </ListItemIcon>
                                        <Typography
                                            className="col-lg-9 col-md-9 col-sm-9 col-9"
                                            style={{
                                                color: "#005BBA",
                                                fontSize: 20,
                                            }}
                                        >
                                            Déconnexion
                                        </Typography>
                                    </MenuItem>
                                </Menu>
                            </div>
                        )}
                    </Toolbar>
                </AppBar>
            </div>
        );
    }
}

MenuAppBar.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        locationTitle: state.locationTitle,
        activeUser: state.activeUser,
        current_day: state.current_day,
        synchro: state.synchro,
        parameter: state.parameter,
        waitingRequests: state.serviceWorker.waitingRequests,
        hideMenu: state.layout.hideMenu,
        interventionsFilters: state.interventions,
        intervention: state.intervention,
        siteMonitoring: state.siteMonitoring,
        siteMonitoringsFilters: state.siteMonitorings.siteMonitoringsFilters,
        componentsPark: state.componentsPark,
        liquidBottle: state.liquidBottle,
        context: state.context,
        currentNews: state.news.currentNews,
        currentInterview: state.form.currentInterview,
        sppFound: state.analyseRisques.sppFound
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        loadLocationTitle: () => dispatch(loadLocationTitle()),
        clearUsers: () => dispatch(clearUsers()),
        getActiveDay: (user_id) => dispatch(getActiveDay(user_id)),
        getImputationToDelete: (user_id, inDb) =>
            dispatch(getImputationToDelete(user_id, inDb)),
        getSynchroActiveUser: (currentState, hideError) =>
            dispatch(ownProps.getSynchroActiveUser(currentState, hideError)),
        downloadHabilitationCard: (user) =>
            dispatch(downloadHabilitationCard(user)),
        getMyLiquidBottles: (user, discreet) =>
            dispatch(getMyLiquidBottles(user, discreet)),
        changeProfileModalState: (profileModalOpened) =>
            dispatch(changeProfileModalState(profileModalOpened)),
        actualizeWaitingRequests: () => dispatch(actualizeWaitingRequests()),
        clearComponentsSearch: () => dispatch(clearComponentsSearch()),
        clearLiquidBottle: () => dispatch(clearLiquidBottle()),
        setDebugging: (debugging) => dispatch(setDebugging(debugging)),
        loadLoggedEmployee: (userId, empId, onSuccess) =>
            dispatch(loadLoggedEmployee(userId, empId, onSuccess)),
        currentImputationsFetchData: (current_day, activeUser) =>
            dispatch(currentImputationsFetchData(current_day, activeUser)),
        synchronization: (
            state,
            stateAccessor,
            history,
            interventionsFilters,
            siteMonitoringsFilters
        ) =>
            dispatch(
                ownProps.synchronization(
                    state,
                    stateAccessor,
                    history,
                    interventionsFilters,
                    siteMonitoringsFilters,
                    true
                )
            ),
    };
};

export default compose(
    withAuth,
    withStyles(styles),
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(MenuAppBar);
